import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';
import CreateFormForItem from './CreateFormForItem';
import {
  COLLECTION_ITEM,
  FieldTypes,
  filterFieldsForForm,
  pluginCode,
  OptionTypeFields,
} from 'drapcode-constant';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import CustomLoader from '../../common/CustomLoader';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import EnvironmentSelect from '../../../common/formElements/EnvironmentSelect';
import showAlert from '../../../common/utils/alert';
import ToggleButton from '../../../common/ui/ToggleButton';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';
import { prepS3Url } from '../../../common/utils/plugin_utils';
const { belongsTo, reference, boolean } = FieldTypes;

class ItemForm extends Component {
  state = {
    saveToAllEnv: false,
    isModalOpen: false,
    installedPlugins: [],
    projectCollections: [],
    environments: [],
  };
  async componentDidMount() {
    const { projectId, version, actions, home } = this.props;
    await actions.loadProjectCollections({ projectId, version });
    const { collections } = this.props;
    const { projectCollections } = collections;
    const { iPlugins } = home;
    const pluginName = iPlugins.map((plugin) => {
      return plugin.code;
    });
    const { projectDetail } = this.props.collections;
    if (projectDetail) {
      this.setState({ environments: [...projectDetail.environments] });
    }
    this.setState({ installedPlugins: pluginName, projectCollections: projectCollections });
    actions.getPermissionFlags({ projectId });
  }
  createSchemaForPluginConfiguration = () => {
    const { collection, item } = this.props;
    const fields = filterFieldsForForm(collection.fields);
    let schema = {};
    Object.keys(fields).map((field) => {
      const fieldDetail = fields[field];
      const { type, refCollection, fieldName } = fieldDetail;
      if (
        type === belongsTo.id ||
        (type === reference.id && refCollection.displayType === 'dropdown')
      ) {
        const innerItems = item ? item[fieldName] : [];
        schema[fieldName] = innerItems
          ? innerItems.map((item) => item.uuid).filter(() => true)
          : [];
      } else if (type === reference.id && refCollection.displayType === 'innerForm') {
        schema[fieldName] = item ? item[fieldName][0] : {};
      } else if (OptionTypeFields.includes(type)) {
        schema[fieldName] = item ? item[fieldName] : [];
      } else if (type === boolean.id) {
        schema[fieldName] = item ? item[fieldName] : false;
      } else {
        schema[fieldName] = item ? item[fieldName] : '';
      }
    });
    return schema;
  };

  prepareValidationForPluginConfiguration = () => {
    const fields = filterFieldsForForm(this.props.collection.fields);
    let validationSchema = {};
    Object.keys(fields).map((field) => {
      const fieldDetail = fields[field];
      const { required, type, fieldName } = fieldDetail;
      if (required) {
        let yupDetail = '';
        if (type === 'text' || type === 'password') {
          yupDetail = Yup.string().required("Can't be blank");
        } else if (type === 'number') {
          yupDetail = Yup.number().required("Can't be blank");
        } else if (type === 'email') {
          yupDetail = Yup.string().email('Not a valid email').required("Can't be blank");
        }
        validationSchema[fieldName] = yupDetail;
      }
    });
    return Yup.object().shape(validationSchema);
  };

  deleteItem = () => {
    const { history, projectId, collection, item, version, actions } = this.props;
    const preConfirm = () => {
      return actions.deleteItem({
        projectId: projectId,
        version,
        collectionName: collection.collectionName,
        itemId: item.uuid,
      });
    };
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!').then((result) => {
      if (result.isConfirmed) {
        history.push(
          `/2.0/collections/${version}/v/${projectId}/items/${collection.uuid}/name/${collection.collectionName}`,
        );
      }
    });
  };

  handleSaveToAllEnvironments = () => {
    this.setState({ saveToAllEnv: !this.state.saveToAllEnv });
  };

  handleSubmit = (values, setErrors, setSubmitting, resetForm) => {
    setSubmitting(false);
    const { item, projectId, collection, actions, history, isNotRedirect, version, projectDetail } =
      this.props;
    const { uuid, collectionName } = collection;
    const collectionUrl = `/2.0/collections/${version}/v/${projectId}/items/${uuid}/name/${collectionName}`;
    if (item) {
      const data = { ...item, ...values };
      actions
        .updateCollectionItem({
          projectId: projectId,
          collectionName: collectionName,
          itemId: item.uuid,
          data: data,
          version,
        })
        .then(() => {
          if (isNotRedirect) {
            resetForm();
            return;
          } else {
            history.push(collectionUrl);
          }
        })
        .catch((err) => {
          setErrors(err);
        });
    } else {
      const performCreate = (environment) => {
        actions
          .saveCollectionItem({
            projectId,
            collectionName: collectionName,
            data: values,
            version,
            environment: environment,
          })
          .then(() => {
            if (isNotRedirect) {
              resetForm();
              actions.loadCollectionItems({
                projectId,
                collectionName: collectionName,
                page: 0,
                version,
              });
              return;
            } else {
              history.push(collectionUrl);
            }
          })
          .catch((err) => {
            setErrors(err);
          });
      };
      if (this.state.saveToAllEnv || collectionName.toLowerCase() === 'role') {
        projectDetail.environments.forEach((env) => {
          performCreate(env.envType);
        });
      } else {
        performCreate();
      }
    }
  };
  showItemForm = () => {
    const {
      collection,
      home,
      projectId,
      version,
      collections,
      item,
      isShowDeleteLoader,
      isShowCreateOrUpdateLoader,
      common,
    } = this.props;
    let { uuid, fields, collectionName } = collection;
    const { permissionFlags } = collections;
    fields = filterFieldsForForm(fields);
    let flag;
    if (permissionFlags && permissionFlags.length > 0) {
      flag = permissionFlags.includes(COLLECTION_ITEM);
    }

    const { iPlugins } = home;
    const s3Url = prepS3Url(iPlugins, common.projectDetail, false);
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createSchemaForPluginConfiguration()}
        onSubmit={(values, { setSubmitting, resetForm, setErrors }) => {
          this.handleSubmit(values, setErrors, setSubmitting, resetForm);
        }}
      >
        {({
          isSubmitting,
          values,
          setFieldValue,
          setFieldTouched,
          setSubmitting,
          setErrors,
          errors,
        }) => (
          <>
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <p className="errors">
                      <ErrorMessage name={'compositeFieldError'} />
                    </p>
                    {fields
                      ? fields.map((field) => (
                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                              <FormFieldWithLabel
                                key={field._id}
                                cta={false}
                                label={field.fieldTitle['en']}
                                icon={
                                  field.type === boolean.id ? `${field.type}-toggle` : field.type
                                }
                                infoIcon={true}
                                infoDescription={''}
                                isRequired={field.required}
                              >
                                <CreateFormForItem
                                  field={field}
                                  values={values}
                                  itemId={item ? item.uuid : null}
                                  collectionId={collectionName}
                                  projectId={projectId}
                                  version={version}
                                  setFieldValue={setFieldValue}
                                  collections={collections}
                                  setSubmitting={setSubmitting}
                                  setErrors={setErrors}
                                  setFieldTouched={setFieldTouched}
                                  plugins={iPlugins}
                                  s3Url={s3Url}
                                />
                              </FormFieldWithLabel>
                            </div>
                          </div>
                        ))
                      : ''}
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <Link
                        className="btn btn-outline-secondary btn-md"
                        role="button"
                        to={`/2.0/collections/${version}/v/${projectId}/items/${uuid}/name/${collectionName}`}
                        title="Cancel"
                      >
                        <i className="wb webconnect-times"></i> Cancel
                      </Link>
                    </div>
                    <div className="col-md-6 text-right">
                      {item && (
                        <button
                          type="button"
                          className="btn btn-theme-delete btn-md"
                          onClick={flag ? this.deleteItem : undefined}
                          style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
                        >
                          <span>
                            <i className="wb webconnect-trash-regular"></i>&nbsp;Delete
                            {flag ? null : (
                              <>
                                &nbsp;
                                <TooltipInfo
                                  title={description}
                                  headerText={`Permission Disabled!`}
                                  showHeader={true}
                                  showArrow={true}
                                />
                              </>
                            )}
                            <CustomLoader loading={isShowDeleteLoader} />
                          </span>
                        </button>
                      )}
                      &nbsp;
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={isSubmitting || isShowCreateOrUpdateLoader}
                      >
                        <i className="wb webconnect-save-regular"></i> {item ? 'Update' : 'Save'}
                        &nbsp;
                        <CustomLoader loading={isShowCreateOrUpdateLoader} />
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </>
        )}
      </Formik>
    );
  };

  reloadItemForm = () => {
    const { refreshItemForm } = this.props;
    if (refreshItemForm) {
      refreshItemForm();
    }
  };

  toggle = () => {
    this.setState({ isModalOpen: !this.state.isModalOpen });
  };

  showExtraButtons = () => {
    const { item, collection, version, projectId } = this.props;
    const { collectionTitle } = collection;
    const { installedPlugins } = this.state;
    const isRoleCollection = collectionTitle.toLowerCase() === 'role' ? true : false;

    if (!item) {
      return (
        <div className="col-3 mt-2 text-right">
          <ToggleButton
            name="saveAllEnvironment"
            title="Add to All Environments"
            text="Add to All Environments"
            isDisabled={isRoleCollection}
            onChange={this.handleSaveToAllEnvironments}
            isChecked={isRoleCollection ? true : this.state.saveToAllEnv}
          />
        </div>
      );
    } else if (
      item &&
      collectionTitle === 'User' &&
      installedPlugins.includes(pluginCode.PERMISSIONS_MANAGE)
    ) {
      return (
        <div className="col-3 text-right">
          <UncontrolledDropdown group className="custom-pad-right-1 pr-2">
            <DropdownToggle color="theme-warning" title="Advanced Options" className="btn-md" caret>
              <i className="wb webconnect-cogs"></i> Advance
            </DropdownToggle>
            <DropdownMenu>
              {installedPlugins.includes(pluginCode.PERMISSIONS_MANAGE) && (
                <Link
                  to={`/2.0/collections/${version}/v/${projectId}/manage-permissions`}
                  className="no-hover"
                  title="Manage Permissions"
                >
                  <DropdownItem title="Manage Permissions" className="theme-green">
                    <i className="wb webconnect-shield-exclamation mt-1"></i>&nbsp;Manage
                    Permissions
                  </DropdownItem>
                </Link>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      );
    } else {
      return <div className="col-3 mt-2"></div>;
    }
  };

  showItemFormlayout = () => {
    const {
      item,
      isAddItemsPage,
      collection,
      projectId,
      version,
      actions,
      history,
      collections,
      home,
    } = this.props;
    const { collectionTitle } = collection;
    const { iPlugins } = home;
    if (!item && isAddItemsPage) {
      return <>{this.showItemForm()}</>;
    } else {
      return (
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <div className="card">
              <div
                className="card-header card-header-icon"
                data-background-color="drapcode-dark-blue"
              >
                <i className={`wb ${drapcodeIcon('form')}`}></i>
              </div>
              <div className="card-title-header pt-3">
                <div className="row mx-auto">
                  <div className="col-3">
                    <h5 className="card-title">
                      {item
                        ? `Modify Data in ${collectionTitle}`
                        : `Add New Data in ${collectionTitle}`}
                    </h5>
                  </div>
                  <div className="col-3 mt-2"></div>
                  {this.showExtraButtons()}
                  <div className="col-3 mt-2">
                    <EnvironmentSelect
                      refreshMethod={() => this.reloadItemForm()}
                      environments={this.props.projectDetail}
                      actions={actions}
                      projectId={projectId}
                      version={version}
                    />
                  </div>
                </div>
              </div>
              <div className="card-content">{this.showItemForm()}</div>
            </div>
          </div>
          <ParentDocCard>
            <h5>
              <b>Add Data in Collection </b>
            </h5>
            <p>
              After creating a collection, you can either add, update or delete data manually or
              bring or edit it dynamically using the events like Save Data, Update Data & Delete
              Data. Data can also be transferred from other databases using data sources like
              Airtable, Firestore, MongoDB, Google Sheet, Firebase Realtime Database & REST API.
            </p>
            <h5>Coming Soon</h5>
            <br />
          </ParentDocCard>
        </div>
      );
    }
  };

  render() {
    const fields = filterFieldsForForm(this.props.collection.fields);
    if (!fields) {
      return (
        <div className="title">
          <h2>No Fields in this collection</h2>
        </div>
      );
    }
    return <>{this.showItemFormlayout()}</>;
  }
}

ItemForm.propTypes = {
  collection: PropTypes.object.isRequired,
  home: PropTypes.object.isRequired,
  common: PropTypes.object.isRequired,
  item: PropTypes.object,
  actions: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
};

export default ItemForm;
